<template>
  <div class="photos">
    <div class="photos-content w1200">
      <h2 class="clum">
        <i class="icon">精彩图集</i>
        <span @click="enterList()">更多</span>
      </h2>
      <ul class="photos-list">
        <li class="list-item" v-for="(item,index) in photosList" :key="index" @click="enterDetaisl(item)">
          <el-card :body-style="{ padding: '10px' }">
            <el-image :src="item.conver"></el-image>
            <!-- <img :src="item.conver" alt=""> -->
            <p>{{item.title}}</p>
          </el-card>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { pageQuery } from '@/api/association'
export default {
  name: 'Photos',
  data () {
    return {
      photosList: [],
      type: this.$route.params.type,
      pageNum: 1
    }
  },
  methods: {
    addPageQuery () {
      let that = this
      console.log(that.loading)
      pageQuery({ pageNo: that.pageNum, pageSize: 4, assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          that.photosList = res.data.data.list
        }
      })
      // that.loading = true
    },
    enterDetaisl (item) {
      this.$router.push({
        name: `ActionMsgDetails`,
        params: {
          id: item.id,
          type: 1
        }
      })
    },
    enterList () {
      this.$router.push({
        name: `ActionMsgList`,
        params: { type: 1 }
      })
    }
  },
  mounted () {

  },
  created () {
    let that = this
    let timer = setInterval(function () {
      let assoId = localStorage.getItem('assoId')
      if (assoId !== undefined && assoId !== null) {
        that.addPageQuery()
        clearInterval(timer)
      }
    }, 200)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .photos{
    width: 100%;
    background-color: #f6f6f6;
  }
  .photos{
    width: 100%;
    padding: 20px 0px 50px 0px;
  }
  .photos-content .clum{
    overflow:hidden;
    margin-bottom: 35px;
  }
  .photos .clum .icon{
    display: inline-block;
    font-size: 24px;
    font-weight: bold;
    background-position: 0px center;
    background-repeat: no-repeat;
    background-size: 5px 24px;
    background-image: url(../../../../static/images/sign_05.png);
    padding-left: 14px;
    font-style: normal;
  }
  .photos-content .clum span{
    float:right;
    font-size:16px;
    color:#409EFF;
    line-height:30px;
    cursor:pointer;
  }
  .photos-list{
    width:100%;
    overflow: hidden;
  }
  .photos-list .list-item{
    width: 236px;
    float: left;
    padding: 10px;
    background: #fff;
    margin-right: 46px;
  }
  .photos-list .list-item:hover{
    transform: scale(1.02)
  }
  .photos-list .list-item:last-child{
    margin-right: 0px;
  }
  .photos-list .list-item img{
    /* width: 236px; */
    height: 236px;
    display: block;
  }
  .photos-list .list-item p{
    font-size: 14px;
    color:#282828;
    overflow: hidden;
    white-space: nowrap;
    text-overflow:ellipsis;
    line-height: 18px;
    margin-top: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/Photos/Photos.vue